import { DetailsCard } from '../../common/DetailsCard';
import { PlanTable } from '../../common/PlanDetails';

type Props = {
  showPediatrics?: boolean;
};

export const PlanComparisonSection = ({ showPediatrics = true }: Props) => (
  <div className='bg-sh-paper w-full'>
    <div className='mx-auto w-full max-w-[1400px] px-4 py-[60px]'>
      <div className='hidden lg:block'>
        <PlanTable showPediatrics={showPediatrics} />
      </div>
      <div className='flex flex-col gap-[40px] rounded-4xl bg-white p-[16px] lg:hidden'>
        <div className='flex flex-col items-center gap-[24px] text-center'>
          <h1 className='text-sh-dark-gray font-serif text-[27px] leading-[115%] font-light'>
            Compare Sollis Memberships
          </h1>
        </div>

        <DetailsCard plan='Signature' />

        <DetailsCard plan='Platinum' />

        {showPediatrics ? <DetailsCard plan='Pediatrics' /> : null}
      </div>
    </div>
  </div>
);
